// allows us to inject a mock date in tests
module.exports = () => new Date();
